/**
 * Theme context shape for Photo Vote Tool — Story 5.2.
 *
 * Source of truth:
 *   - UX spec §2.1 lines 75-91 (two-theme persistence rules; prefers-color-scheme first-visit-only)
 *   - Architecture §2.5 lines 240-256 (theme cookie + edge-function contract)
 *
 * The `Theme` alias is intentionally narrow (`'dark' | 'light'`). Any external
 * value (cookie, localStorage, `<html data-theme>`) that is not literally one
 * of these two strings is treated as "no preference" and falls through to the
 * next priority level in `ThemeProvider`'s initial-value resolution chain.
 *
 * `ThemeContext` is created with `null` as the empty value (mirrors Story 1.9's
 * `AuthContext` shape). Consumers MUST go through `useTheme()` (Story 5.2's
 * `web/src/theme/useTheme.ts`), which throws on null rather than null-derefing
 * downstream.
 */
import { createContext } from 'react';

export type Theme = 'dark' | 'light';

export interface ThemeContextValue {
  theme: Theme;
  setTheme: (next: Theme) => void;
  toggleTheme: () => void;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);
